import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
// import { CheckCircleIcon } from "@heroicons/react/solid"; // 🎨 Success Icon
import { CheckCircleIcon } from "@heroicons/react/24/solid"; 
import { host } from "../../api/ApiCalls";


const PaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  // const sessionId = searchParams.get("session_id");
  const navigate = useNavigate();
  const [message, setMessage] = useState("Processing Payment...");
  const [status, setStatus] = useState("loading"); // "loading" | "success" | "error"

  // useEffect(() => {
  //   console.log("🔄 Session ID received from URL:", sessionId);

  //   // setTimeout(() => {
  //   //   if (!sessionId) {
  //   //     setMessage("❌ Payment Verification Failed: Session ID not found!");
  //   //     setStatus("error");
        
  //   //     setTimeout(() => {
  //   //       navigate("/payment-cancel");
  //   //     }, 5000); // Delay for 5 seconds before redirect
  //   //   }
  //   // }, 5000); // Delay for 5 seconds before redirect
    
      

  //   const verifyPayment = async () => {
  //     try {
  //       console.log("🔄 Sending session_id to backend:", sessionId);
  //       const response = await axios.post("http://localhost:4000/api/payments/verify-payment", { session_id: sessionId });

  //       console.log("✅ Payment Verification Response:", response.data);
  //       setMessage(response.data.message || "✅ Payment Verified! You are now enrolled.");
  //       setStatus("success");

  //       // 🔄 Redirect after 7 seconds
  //       setTimeout(() => {
  //         navigate("/courses"); // Change this to your enrolled courses page
  //       }, 20000);
  //     } catch (error) {
  //       console.error("❌ Payment Verification Error:", error.response?.data || error.message);
  //       setMessage("❌ Payment Verification Failed: " + (error.response?.data.error || "Unknown Error"));
  //       setStatus("error");

  //       // Redirect to cancel page after 7 seconds
  //       setTimeout(() => {
  //         navigate("/payment-cancel");
  //       }, 7000);
  //     }
  //   };

  //   verifyPayment();
  // }, [sessionId, navigate]);

  const [verified, setVerified] = useState(false);
  const [sessionId, setSessionId] = useState(null);

useEffect(() => {
  const params = new URLSearchParams(window.location.search);
  const id = params.get("session_id");
  if (id) {
    setSessionId(id);
  }
}, []);

useEffect(() => {
  if (!sessionId || verified) return; // Agar sessionId na ho ya pehle se verified ho to return karo

  console.log("🔄 Session ID received from URL:", sessionId);
  setVerified(true); // Prevent duplicate calls

  const verifyPayment = async () => {
    try {
      console.log("🔄 Sending session_id to backend:", sessionId);
      const response = await axios.post(`${host}/api/payments/verify-payment`, { session_id: sessionId });

      console.log("✅ Payment Verification Response:", response.data);
      setMessage(response.data.message || "✅ Payment Verified! You are now enrolled.");
      setStatus("success");

      // Redirect after 5 seconds
      setTimeout(() => {
        navigate("/courses");
      }, 5000);
    } catch (error) {
      console.error("❌ Payment Verification Error:", error.response?.data || error.message);
      setMessage("❌ Payment Verification Failed: " + (error.response?.data.error || "Unknown Error"));
      setStatus("error");

      // Redirect after 5 seconds
      setTimeout(() => {
        navigate("/payment-cancel");
      }, 5000);
    }
  };

  verifyPayment();
}, [sessionId, navigate, verified]);


  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-100">
      <div className="bg-white p-6 rounded-lg shadow-lg text-center">
        {status === "success" ? (
          <CheckCircleIcon className="h-16 w-16 text-green-500 mx-auto mb-4 animate-bounce" />
        ) : status === "error" ? (
          <span className="text-red-500 text-5xl">❌</span>
        ) : (
          <div className="h-16 w-16 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        )}

        <h2 className={`text-xl font-semibold ${status === "success" ? "text-green-600" : "text-gray-800"}`}>
          {message}
        </h2>
        <p className="text-gray-500 mt-2">
          {status === "success"
            ? "Redirecting you to your enrolled courses..."
            : "Please wait or try again."}
        </p>

        <div className="mt-6">
          {status === "success" ? (
            <button
              onClick={() => navigate("/dashboard")}
              className="bg-green-500 text-white px-4 py-2 rounded-md hover:bg-green-600"
            >
              Go to Dashboard
            </button>
          ) : (
            <button
              onClick={() => navigate("/payment-cancel")}
              className="bg-red-500 text-white px-4 py-2 rounded-md hover:bg-red-600"
              disabled
            >
              Loading
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
